import HmEventRegistry from './../model/HmEventRegistry';
const native_ajax_duplicate_interval = (window.ajax_calls_restrict_duplicate && !isNaN(window.ajax_calls_restrict_duplicate["native"])) ? window.ajax_calls_restrict_duplicate["native"] : 2;
const native_ajax_duplicate_prevent_methods = ["GET"];
/**
* Native Ajax enables CORS requests.
*/
let NativeAjax = function(url,data){
	var availableMethods = ['GET','POST','PUT'];
	var paramStr = "";
	var withCredentials = false;
	var defaultHeaders = {
		"Content-type": "application/json;charset=UTF-8",
		'Accept':  '*'  
	};

	let maskEnabled = false;
	let maskType = null;

	let reqBodyTypePreference = "string";
	
	
	let processHeaders = function(request){
		if(defaultHeaders && typeof defaultHeaders === "object"){
			for(let i in defaultHeaders){
				request.setRequestHeader(i,defaultHeaders[i]);
			}
		}

		request.withCredentials = withCredentials;

		return request;
	}

	let pushDataToCache = function(data){
		try{
			if(window._native_ajax_requests_map && window._native_ajax_requests_map[url]){
				window._native_ajax_requests_map[url].data = data;
			}			
		}catch(e){
			console.error("error occurred while pushing data to cache :" , e);
		}
	}

	this.mask = function(inMaskType=null){
		maskEnabled = true;
		maskType = inMaskType;

		return this;
	}

	//To enable CORS request
	this.enableCORS = function(){
		withCredentials = true;

		return this;
	}

	this.setFormData = function(formObj){
		reqBodyTypePreference = "object";
		var formData = new FormData();
		if(formObj){
			for(var i in formObj){
				formData.append(i, formObj[i]);
			}
		}

		defaultHeaders = {};

		data = formData;		
		return this;
	}

	this.setHeaders = function(headers){
		if(headers && typeof headers === "object"){
			for(var i in headers){
				defaultHeaders[i] = headers[i];
			}
		}

		return this;
	}
	
	this.preferObject = function(type){
		if(type)
			reqBodyTypePreference = type;
		
		return this;
	}

	if(data != null){
		paramStr = "?";
		var tempIndex = 0;
		for(var i in data){
			if( tempIndex > 0){
				paramStr += "&";  
			}
			paramStr += i + "=" + data[i];
			tempIndex ++;
		}
	}

	this.get = function(success, failure){
		this.connect('GET',success, failure);
	}

	this.post = function(success, failure){
		this.connect('POST',success, failure);
	}

	this.put = function(success, failure){
		this.connect('PUT',success, failure);	
	}

	this.connect = function(method, success, failure){
		if(availableMethods.indexOf(method) === -1){
			//if method not defined, default is applied
			method = availableMethods[0];
		}

		// Feature detection
		if ( !window.XMLHttpRequest ) return;
		// Create new request
		var request = new XMLHttpRequest();
		//enable CORS
		request.withCredentials = withCredentials;

		request.onreadystatechange = function () {
			// If the request is complete
			if ( request.readyState === 4 ) {
				// If the request failed
				if ( request.status !== 200 ) {
					if ( failure && typeof failure === 'function' ) {
						let response = {};						
						try{
							response = JSON.parse(request.responseText);
						}catch(e){
							response = request.responseText;
						}

						pushDataToCache(response);

						try{
							failure( response, request );	
						}catch(e){
							console.error("Error occurred while executing failure callback", e);
						}
						if(maskEnabled){
							HmEventRegistry.fireEvent("HIDE_MASK");
						}
						
					}
					return;
				}
				// If the request succeeded
				if ( success && typeof success === 'function' ) {
					let response = {};
					try{
						response = JSON.parse(request.responseText);
					}catch(e){
						response = request.responseText;
						//console.error(e);
					}

					pushDataToCache(response);

					try{
						success( response, request );
					}catch(e){
						console.error("Error occurred while executing success callback", e);
					}
					if(maskEnabled){
						HmEventRegistry.fireEvent("HIDE_MASK");
					}					
				}

				return;
			}
		};


		/**
		* This temp Data will be used as model data for duplicate requests
		*/
		let tempData = null;

		/**
		* IMPORTANT: Check for duplicate requests and suppress them here.
		*/
		if(native_ajax_duplicate_prevent_methods && method && native_ajax_duplicate_prevent_methods.includes(method.toUpperCase())){
			window._native_ajax_requests_map = window._native_ajax_requests_map || {};
			let currentTime = Math.round(new Date().getTime() / 1000);
			if(window._native_ajax_requests_map[url] && window._native_ajax_requests_map[url].data && !isNaN(window._native_ajax_requests_map[url].time) && (currentTime - window._native_ajax_requests_map[url].time) <=  native_ajax_duplicate_interval){
				if(typeof success === "function"){
					success.apply(this,[window._native_ajax_requests_map[url].data, {"preloaded":true}]);	
				}

				console.log("Preventing duplicate request. preset interval :", native_ajax_duplicate_interval);
				return;
			}else{
				let tempObj = {
					time: currentTime,
					data: (window._native_ajax_requests_map[url] && window._native_ajax_requests_map[url].data) ? window._native_ajax_requests_map[url].data : null
				};
				window._native_ajax_requests_map[url] = tempObj;

				setTimeout(() => {
					delete window._native_ajax_requests_map[url];
				}, (native_ajax_duplicate_interval * 1000));
			}
		}
		
		if(paramStr != null){
			if(maskEnabled){
				HmEventRegistry.fireEvent("SHOW_MASK", {maskType:maskType});	
			}

			if(method === 'GET'){
				url += paramStr; 
				request.open( method , url, true);
				request = processHeaders(request);
				request.send();
			}else{
				request.open( method , url, true);
				request = processHeaders(request);
				if(reqBodyTypePreference === "object"){
					request.send(data);
				}else{
					request.send(JSON.stringify(data));
				}

			}
		}else{
			console.error("No Params to request to Host machine.");
		}

	}
}


export default NativeAjax;


// WEBPACK FOOTER //
// ./src/util/NativeAjax.js